module.exports = __webpack_public_path__ + "static/media/bi_hraswo.48505155.ogg";